import { render } from "./person-role-create.vue?vue&type=template&id=4ec83771"
import script from "./person-role-create.vue?vue&type=script&lang=js"
export * from "./person-role-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__